import uuidv4 from 'uuid/v4'

export const NATURAL_PERSON = 1
export const GEMEINDE = 2
export const OTHER = 3

const defaultValues = {
  [NATURAL_PERSON]: {
    type: NATURAL_PERSON,
    firstName: '',
    lastName: '',
    vulgo: '',
    stand: ''
  },
  [GEMEINDE]: {
    type: GEMEINDE,
    name: ''
  },
  [OTHER]: {
    type: OTHER,
    name: ''
   }
}

const defaultTypes = [
  { id: NATURAL_PERSON, label: "Person" },
  { id: GEMEINDE, label: "Gemeinde" },
  { id: OTHER, label: "Sonstige" }
]

const state = () => ({
  ownersById: {
    1: { id: 1, type: 1, firstName: "Johann", lastName: "Troppmair", vulgo: "Lehner", stand: "Elektriker" },
    2: { id: 2, type: 2, name: "Gemeinde Finkenberg" }
  },
  ownerIds: [1, 2],
  swappedOwnersById: {}
})

function genId() {
  return uuidv4().replace('-')
}

const mutations = {
  ADD(state) {
    const id = genId()

    state.ownersById[id] = {
      id,
      ...defaultValues[NATURAL_PERSON]
    }
    state.ownerIds.push(id)
  },
  POP(state) {
    if (state.ownerIds.length > 0) {
      const id = state.ownerIds.pop()
      delete state.ownersById[id]
    }
  },
  SWAP(state, { id, type }) {
    // NOTE: this swaps one type for another, id stays the same, backs up previous value so existing input is not lost
    if (id in state.ownersById) {
      if (type in defaultValues) {

	const oldValue = state.ownersById[id]

	// store old values
	state.swappedOwnersById[id] = {
	  ...state.swappedOwnersById[id],
	  [oldValue.type]: oldValue
	}

	// restore prev value if possible
	if (id in state.swappedOwnersById && type in state.swappedOwnersById[id]) {
	  state.ownersById[id] = {
	    id,
	    ...state.swappedOwnersById[id][type]
	  }
	}
	else {
	// change to new type
	  state.ownersById[id] = {
	    id,
	    ...defaultValues[type]
	  }
	}
      }
      else {
	console.warn(`Invalid type '${type}'`)
      }
    }
    else {
      console.warn(`Invalid id '${id}'`)
    }
  }
}

const actions = {
  add({ commit }) {
    commit('ADD', { ...defaultValues[NATURAL_PERSON] })
  },
  pop({ commit }) {
    commit('POP')
  },
  swap({ commit }, { id, type }) {
    commit('SWAP', { id, type })
  }
}

const getters = {
  owners: (state) => state.ownerIds.map((id) => state.ownersById[id]),
  types: (state) => defaultTypes,
  findOwnerById: (state) => (id) => state.ownersById[id]
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
